// removed by extract-text-webpack-plugin
module.exports = {"displayNumCol":"index__displayNumCol___1l9hn","message":"index__message___1kN4E","deleteIcon":"index__deleteIcon___3oMjq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/FilterCriteria/components/Criterion/index.less
// module id = 1888
// module chunks = 3